<div class="container-fluid mt-2">
  <ngx-alerts></ngx-alerts>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="table-responsive mt-3">
            <table class="table table-centered datatable dt-responsive nowrap"
                   style="border-collapse: collapse; border-spacing: 0; width: 100%;">
              <thead class="thead-light">
              <tr>
                <th>S.No.</th>
                <th>Commission Amount</th>
                <th>Buyer Contact Number</th>
                <th>Amount Credited to Wallet</th>
                <th>CreatedOn</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let item of userReferrals; let i= index">
                <td>{{i + 1}}</td>
                <td>{{'₹' + item.amount}}</td>
                <td>{{item.buyerPhoneNumber}}</td>
                <td>
                  <span class="text-success" *ngIf="item.amountCreditedToWallet"><i class="fa fa-check"></i></span>
                  <span class="text-danger" *ngIf="!item.amountCreditedToWallet"><i class="fa fa-times"></i></span>
                </td>
                <td>{{item.createdOn | date :'medium'}}</td>
              </tr>
              </tbody>
            </table>
            <mat-paginator (page)="pageEvent = getServerData($event)" [length]="totalRecords"
                           [pageSize]="search.size"
                           [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
